import React from 'react';
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  EmailShareButton,
  LinkedinShareButton,
} from 'react-share';
import IconButton from './IconButton';

interface props {
  link: string;
}

const SocialIcons: React.FC<props> = ({ link }) => {
  const instagramDirectLink = `https://www.instagram.com/direct/new/?text=${link}`;
  const socialIconsList = [
    {
      icon: (
        <FacebookShareButton url={link} title={`please checkout my profile`}>
          <IconButton
            src="/assets/svgs/fi_facebook.svg"
            effectDarkness={1}
            className="p-6 bg-[#9D9D9D0A] size-100"
          />
        </FacebookShareButton>
      ),
      label: 'Facebook',
    },
    {
      icon: (
        <a href={instagramDirectLink} target="_blank" rel="noopener noreferrer">
          <IconButton
            src="/assets/svgs/fi_instagram.svg"
            effectDarkness={1}
            className="p-6 bg-[#9D9D9D0A] size-100"
          />
        </a>
      ),
      label: 'Instagram',
    },
    {
      icon: (
        <TwitterShareButton title="Above is my link to the post" url={link}>
          <IconButton
            src="/assets/svgs/fi_x.svg"
            effectDarkness={1}
            className="p-6 bg-[#9D9D9D0A] size-100"
          />{' '}
        </TwitterShareButton>
      ),
      label: 'X',
    },
    {
      icon: (
        <WhatsappShareButton url={link}>
          <IconButton
            src="/assets/svgs/fi_whatsapp.svg"
            effectDarkness={1}
            className="p-6 bg-[#9D9D9D0A] size-100"
          />
        </WhatsappShareButton>
      ),
      label: 'Whatsapp',
    },
    {
      icon: (
        <EmailShareButton url={link} title="this is my link">
          <IconButton
            src="/assets/svgs/fi_email.svg"
            effectDarkness={1}
            className="p-6 bg-[#9D9D9D0A] size-100"
          />
        </EmailShareButton>
      ),
      label: 'E-mail',
    },
    {
      icon: (
        <LinkedinShareButton url={link} title="this is my link">
          <IconButton
            src="/assets/svgs/fi_linkedin.svg"
            effectDarkness={1}
            className="p-6 bg-[#9D9D9D0A] size-100"
          />
        </LinkedinShareButton>
      ),
      label: 'LinkedIn',
    },
  ];

  return (
    <div className="flex flex-wrap gap-4 items-center mt-[46px] mb-[46px] md:mb-16">
      {socialIconsList.map(({ icon, label }, index) => (
        <div key={index} className="flex flex-col items-center text-center">
          {icon}
          <span className="hidden md:block text-[#113E53] mt-2 text-xs">
            {label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default SocialIcons;
